module.exports = __webpack_public_path__ + "5a020e7cad74a13c1d530716e01e52f9.fbx";